module.exports = __webpack_public_path__ + "img/api_logo.29d4662f.png";